<template>
  <div id="container">
    <div class="box-content-title">
      <div class="title-font-style">
        <span>团队合同记录</span>
      </div>
    </div>
    <el-form class="search-style">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-form-item>
            <el-select v-model="queryParams.column" @change="onChangeColumn">
              <el-option
                v-for="(item, index) in teamContractRecord"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4" v-show="queryParams.column === 'contractTotal'">
          <el-form-item>
            <el-select v-model="queryParams.expression">
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="(item, index) in expressionList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-select
              v-model="queryParams.value"
              v-if="queryParams.column==='signState' || queryParams.column==='payType'"
            >
              <el-option
                v-for="(item, index) in selectList"
                :key="index"
                :label="item.lab"
                :value="item.val"
              ></el-option>
            </el-select>
            <el-date-picker
              style="width:100%"
              v-else-if="queryParams.column==='signDate'"
              v-model="time"
              :default-time="['00:00:00','23:59:59']"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
            <el-input v-else v-model="queryParams.value" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item></el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item>
            <el-button type="primary" @click="onSearch">搜索</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="box-table" :style="{height: $store.state.Sell.heightTitle+'px'}">
      <el-table
        border
        ref="tableRef"
        :data="list"
        :max-height="$store.state.Sell.heightTitle"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column label="合同编号" width="150px" fixed>
          <template slot-scope="scope">
            <span class="approval" @click="toHeTong(scope.row)">{{ scope.row.contractCode }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cusName" label="客户名称" width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="toKeHu(scope.row)"
            >{{ scope.row.cusName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="客户合同编号" width="150px">
          <template slot-scope="scope">{{scope.row.customerContractCode| '--'}}</template>
        </el-table-column>
        <el-table-column label="付款类型">
          <template slot-scope="scope">{{scope.row.payType|payTypeFilters}}</template>
        </el-table-column>
        <el-table-column prop="contractTotal" label="合同金额" width="100">
          <template slot-scope="scope">{{scope.row.contractTotal|priceFilter}}</template>
        </el-table-column>
        <el-table-column prop="stockupUnPrice" label="实际供货成本" width="120">
          <template slot-scope="scope">{{ scope.row.stockupUnPrice|priceFilter}}</template>
        </el-table-column>
        <el-table-column label="毛利率">
          <template slot-scope="scope">{{ scope.row.contractRate|perCentFilter}}</template>
        </el-table-column>
        <el-table-column label="合同状态" width="110">
          <template slot-scope="scope">{{scope.row.signState|signStateFilters}}</template>
        </el-table-column>
        <el-table-column prop="deliverState" label="发货状态"></el-table-column>
        <el-table-column prop="accountsReceived" label="已收账款">
          <template slot-scope="scope">{{ scope.row.accountsReceived|priceFilter}}</template>
        </el-table-column>
        <el-table-column prop="accountsDue" label="已到期账款" width="120px">
          <template slot-scope="scope">{{ scope.row.accountsDue|priceFilter}}</template>
        </el-table-column>
        <el-table-column prop="invoiceState" label="开票状态" width="110px"></el-table-column>
        <el-table-column prop="count" label="售后记录"></el-table-column>
        <el-table-column prop="staffCnName" label="当前负责人" width="120px"></el-table-column>
        <el-table-column prop="orgName" label="所属部门"></el-table-column>
        <el-table-column label="签订时间" width="140">
          <template slot-scope="scope">{{scope.row.signDate|dateFilter}}</template>
        </el-table-column>
        <el-table-column prop="updateDate" label="更新时间" width="140">
          <template slot-scope="scope">{{scope.row.updateDate|dateFilter}}</template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <pagination
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
    </div>
  </div>
</template>
<script>
import { teamContractRecord } from './util/data'
import { contractRecordTeam } from '@/api/sell/sellManage'
import { expressionList } from '@/components/utils/data'
import pagination from '@/components/pagination'
export default {
  components: { pagination },
  data() {
    return {
      payTypeList: [
        { lab: '约定账期', val: 1 },
        { lab: '全款发货', val: 2 },
        { lab: '先货后款', val: 3 },
        { lab: '期货期款', val: 4 }
      ], // 发票类型
      signStateList: [
        { lab: '待审核', val: 1 },
        { lab: '审核中', val: 2 },
        { lab: '待签署', val: 3 },
        { lab: '履行中', val: 4 },
        { lab: '已履行', val: 5 },
        { lab: '已作废', val: 6 },
        { lab: '审核不通过', val: 7 },
        { lab: '盖章审核', val: 8 }
      ], // 开票状态
      columnArr: [],
      selectList: [],
      expressionList,
      queryParams: {
        column: 'cusName',
        value: ''
      },
      teamContractRecord, // 搜索下拉数据
      list: [], // 列表数据
      loadingTable: false, // 列表loading
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      time: [],
      total: 0 // 列表总数
    }
  },
  watch: {
    queryParams (val) {
      if (!val.column) {
        this.$set(this.queryParams, 'column', 'cusName')
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    onSearch() {
      // 搜索
      if (this.time.length === 2) {
        this.queryParams.value = this.time[0]
        this.queryParams.endValue = this.time[1]
      }
      if (this.queryParams.column && this.queryParams.value) {
        this.pageSize = 30
        this.currentPage = 1
        this.columnArr = [this.queryParams]
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    onReset() {
      this.columnArr = []
      this.queryParams = {}
      this.currentPage = 1
      this.pageSize = 30
      this.getList()
    },
    // 客户详情
    toKeHu(row) {
      this.$router.push({
        path: '/crm/customer/details',
        query: { id: row.cusId }
      })
    },
    // 合同详情
    toHeTong(row) {
      if (row.signState === 4 || row.signState === 5) {
        this.$router.push({
          name: 'contractEdit',
          query: { id: row.id, cusId: row.cusId }
        })
      } else {
        this.$router.push({
          name: 'contractCreate',
          query: { id: row.id }
        })
      }
    },
    getList() {
      this.loadingTable = true
      const obj = {
        criteriaVoList: [...this.columnArr],
        queryPageName: ''
      }
      contractRecordTeam(this.currentPage, this.pageSize, obj).then((res) => {
        if (res.data.code === 200) {
          this.loadingTable = false
          this.list = res.data.obj.records
          this.total = res.data.obj.total
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onChangeColumn(val) {
      // 改变下拉框
      this.time = []
      this.queryParams = {}
      this.queryParams.column = val
      this.$set(this.queryParams, 'expression', null)
      if (this.queryParams.column === 'payType') {
        this.selectList = this.payTypeList
      }
      if (this.queryParams.column === 'signState') {
        this.selectList = this.signStateList
      }
      if (this.queryParams.column === 'contractTotal') {
        this.queryParams.expression = 'eq'
      }
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
